import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useIdelinkTheme } from '../../../configs/IdeLinkTheme';
import { ItemState } from '../../../services/commons/ItemState';
import { AdminPermission } from '../../../services/commons/Me';
import {
    AdminPermissions,
    AdminPermissionsOnModule,
} from '../../../services/commons/Permissions/AdminPermissions';
import {
    ContentPermission,
    UserPermissions,
    UserPermissionsOnContent,
} from '../../../services/commons/Permissions/ContentPermission';
import { PermissionsAbilityHelper } from '../../../services/commons/Permissions/PermissionsAbilityHelper';
import { TabPermissionItem } from '../../BackUsers/Pages/components/PermissionsTreeContainer/PermissionsTreeContainer';

export interface UserPermissionsOnChallenge extends UserPermissionsOnContent {
    readonly canAddChallengeQuestions?: boolean;
    readonly canRemoveChallengeQuestions?: boolean;
    readonly canDisabledAddChallengeQuestions?: boolean;
    readonly canAddAnswers?: boolean;
    readonly canUpdateQuestionsOrder?: boolean;

    readonly canEditQuestionTitle?: boolean;
    readonly canEditQuestionType?: boolean;
    readonly canEditQuestionExternalReference?: boolean;
    readonly canEditQuestionLabel?: boolean;
    readonly canEditQuestionDescription?: boolean;

    readonly canEditAnswerTitle?: boolean;
    readonly canEditAnswerActionType?: boolean;
    readonly canEditAnswerExternalReference?: boolean;
    readonly canRemoveAnswer?: boolean;
}
export class ChallengesPermissions {
    public static CHALLENGES_TAB_HASH = '#rights-challenges';
    //public static CHALLENGES_KEY = 'CHALLENGES_KEY';
    public static CHALLENGES_CODE = 'Challenges';

    public static Admin: AdminPermissionsOnModule = {};

    public static getChallengesTab = (): TabPermissionItem => ({
        hash: ChallengesPermissions.CHALLENGES_TAB_HASH,
        label: (
            <FormattedMessage id="backofficeUsers.create.tabs.permissions.sectionTabs.challenges" />
        ),
        getIcon: () => useIdelinkTheme().challenges.permissionIcon,
        getIconSelected: () => useIdelinkTheme().challenges.permissionSelectedIcon,
    });

    public static initializeChallengesAdminPermissions = (perms: Array<AdminPermission> = []) => {
        const permsOnChallenges = AdminPermissions.filter(
            perms,
            ChallengesPermissions.CHALLENGES_CODE
        );
        ChallengesPermissions.Admin = AdminPermissions.toPermissions(permsOnChallenges);
        PermissionsAbilityHelper.logPermissions('Challenges', ChallengesPermissions.Admin);
    };

    public static toDefaultChallengePermissions = (): UserPermissionsOnChallenge => {
        const rawPermissions: UserPermissionsOnChallenge =
            ChallengesPermissions.toUserPermissionsOnChallenge(ItemState.Draft);
        const permissions: { [field: string]: boolean } = {};
        Object.keys(rawPermissions).forEach((key) => (permissions[key] = true));
        return permissions as UserPermissionsOnChallenge;
    };

    public static toUserPermissionsOnChallenge = (
        contentState: ItemState,
        contentPermission?: ContentPermission
    ): UserPermissionsOnChallenge => {
        const canEdit = UserPermissions.canEdit(contentState, contentPermission);
        return {
            ...UserPermissions.toUserPermissionsOnContent(contentState, contentPermission),
            canAddChallengeQuestions: canEdit,
            canRemoveChallengeQuestions: canEdit,
            canAddAnswers: canEdit,
            canUpdateQuestionsOrder: canEdit,

            canEditQuestionTitle: canEdit,
            canEditQuestionType: canEdit,
            canEditQuestionExternalReference: canEdit,
            canEditQuestionLabel: canEdit,
            canEditQuestionDescription: canEdit,

            canEditAnswerTitle: canEdit,
            canEditAnswerActionType: canEdit,
            canEditAnswerExternalReference: canEdit,
            canRemoveAnswer: canEdit,
        };
    };
}
